<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-cascader ref='cascader2'
          v-model="theBusinessType" clearable filterable
          size='small'
          placeholder='请选择分类'
          :show-all-levels='false'
          :options="getBusinessTypeListAll_data ? getBusinessTypeListAll_data.data : []"
          :props="{ expandTrigger: 'hover', checkStrictly: false, emitPath: false, label: 'btName', value: 'btId', children: 'children' }"
          @change="theBusinessTypeChange" >
          <template slot-scope="{ data }" >
            <span onclick="this.parentNode.previousElementSibling.click()" >{{ data.btName }}</span>
          </template>
        </el-cascader>
        <el-input
          v-model="getBusinessList_data.businessName"
          placeholder="请输入业务名"
          clearable
          size='small'
          style="max-width:380px;"/>
        <el-button
          v-click.getBusinessList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
      <el-col :span="6" >
        <el-button v-if="addBusiness"
          @click=" $form('addBusiness'),getBusinessTypeList({pageSize:0})"
          size='small'
          type="primary"
          style="float:right"
          icon='el-icon-circle-plus'
        >添加业务
        </el-button>
      </el-col>
    </el-row>

    <mytable
      :tableColums='tableColums_getBusinessList'
      api='getBusinessList'
      xupdateapi='updateBusiness'
      :height="H-165" >
      <icol slot='ouMilestoneList' slot-scope='{row}' show-overflow-tooltip>
        <el-row>
          <el-col :span="20">
            <el-steps simple size="mini">
              <el-step v-for="item in row.ouMilestoneList" :title="item.mtName" :key="item.mtId"></el-step>
            </el-steps>
          </el-col>
          <el-col :span="4">
            <el-button size="small" type="text" @click="toEditOuMilestone(row)">编辑</el-button>
          </el-col>
        </el-row>
      </icol>
    </mytable> 

    <myform
      :viewobj='{
        addBusiness:    [ "新增业务信息", "el-icon-circle-plus" ],
        updateBusiness: [ "修改业务信息", "el-icon-edit-outline"],
        $succeed$: getBusinessList
      }'
      @close='$form("addBusiness","reset")' >
      <hide slot='businessId' />
      <hide slot='businessIds' />
      <template v-slot:businessIds="{Myformdata}" >
        <el-select v-model='Myformdata.businessIds' clearable multiple>
            <el-option
                v-for="item in getBusinessTypeList_data.data||[]"
                :key="item.btId"
                :label="item.btName"
                :value="item.btId">
            </el-option>
        </el-select>
  	  </template>
      <template v-slot:bcId="{Myformdata}" >
        <el-select v-model='Myformdata.bcId' clearable multiple>
            <el-option
                v-for="item in getBusinessClassList_data.data ||[]"
                :key="item.bcId"
                :label="item.bcName"
                :value="item.bcId">
            </el-option>
        </el-select>
  	  </template>
    </myform>
    <myform
      view.ouMilestoneDetails="里程碑"
      @opened='arguments[0].title += " | @" + row.businessName'
      @close='$form("ouMilestoneDetails","hide"),getBusinessList()'
    >
      <el-button v-if="addOuMilestone"
        @click=" $form('addOuMilestone') "
        size='small'
        type="primary"
        style="float:right"
        icon='el-icon-circle-plus'
      >添加里程碑
      </el-button>
      <mytable
        :tableColums='tableColums_getOuMilestoneList'
        api='getOuMilestoneList'
        updateapi='updateOuMilestone'
        :height="H-285"
      />
      <hide slot='businessId' />
    </myform>

    <myform
      :viewobj='{
        addOuMilestone:    [ "新增里程碑信息", "el-icon-circle-plus" ],
        updateOuMilestone: [ "修改里程碑信息", "el-icon-edit-outline"],
        $succeed$: getOuMilestoneList
      }'
      @close='$form("addOuMilestone","reset")' 
      @confirm='myformOuMilestone'>
      <hide slot='mtId' />
      <hide slot='businessId' />
    </myform>
  </div>
</template>

<script>
export default {
  data() {
    return {
      businessId: null,
      row:{},
      theBusinessType:"",

      tableColums_getBusinessList: {
        $selection: false,

        businessName: '业务名称',
        bcName:'业务分类名称',

        ouMilestoneList: ['里程碑',500],

        businessRemark: '描述',

        createtime: '创建时间',

        $operation: [
          '操作', 200,
          this.updateBusiness && `@text: 编辑#success
           @click: $form("updateBusiness",$row)
          `,
          // this.updateBusiness && `@text: 编辑#success
          //  @click: $form("updateBusiness",$row), getBusinessOne({businessId:$row.businessId}).trigger(res=>Myformdata.businessIds = $Parse(res.data.data.businessIds))
          // `,
          this.deleteBusiness && `@text: 删除#danger
           @click: _confirm('确定要删除该业务吗?')
                   .trigger('deleteBusiness',{businessId:$row.businessId})
                   .trigger('getBusinessList')
          `,
        ],

      },

      tableColums_getOuMilestoneList: {
        $selection: false,

        mtName: '里程碑名称',

        mtRemark: '描述',

        mtOrder: '排序',

        $operation: [
          '操作', 200,
          this.updateOuMilestone && `@text: 编辑#success
           @click: $form("updateOuMilestone",$row)
          `,
          this.deleteOuMilestone && `@text: 删除#danger
           @click: _confirm('确定要删除该里程碑吗?')
                   .trigger('deleteOuMilestone',{mtId:$row.mtId})
                   .trigger('getOuMilestoneList({businessId:row.businessId})')
          `,
        ],

      },

    };
  },

  watch: {
    
  },

  methods: {
    toEditOuMilestone(row){
      this.$form("ouMilestoneDetails", this.row = row);
      this.getOuMilestoneList({businessId:row.businessId})
    },
    myformOuMilestone(submit, Myformdata) {
      Myformdata.businessId = this.row.businessId;
      submit();
    },
    theBusinessTypeChange(e){
      this.theBusinessId="";
      this.theBusinessType=e;
      console.log(this.theBusinessType)
      this.getBusinessList({businessIds:this.theBusinessType});
    },
  },

  created() {
    this.getBusinessClassList()
    this.getBusinessTypeListAll();
    this.getBusinessTypeList({pageSize:0});
    this.getBusinessList({businessIds:this.theBusinessType});
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/bussiness/BussinessManage.vue